import { connect, ConnectedProps } from "react-redux";

import { withRouter } from "react-router";
import {
  getDepartureDateBucketsCallState,
  getDepartureMonths,
  getHasOriginAutocompleteError,
  getOrigin,
  getPriceRangeLegends,
  getUserFlightPreferences,
  getUserFlightPreferencesCallState,
} from "../../reducer/selectors";
import { IStoreState } from "../../../../reducers/types";
import { MonthAndDatePicker } from "./component";

const mapStateToProps = (state: IStoreState) => ({
  months: getDepartureMonths(state),
  priceTags: getPriceRangeLegends(state),
  priceBucketsLoadingCallState: getDepartureDateBucketsCallState(state),
  searchedOrigin: getOrigin(state),
  hasOriginAutocompleteError: getHasOriginAutocompleteError(state),
  userFlightPreferences: getUserFlightPreferences(state),
  userFlightPreferencesCallState: getUserFlightPreferencesCallState(state),
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MonthAndDatePickerConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedMonthAndDatePicker = withRouter(
  connector(MonthAndDatePicker)
);
